import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    fp12m(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fp/fp12m${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    fp12mexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const response = await axios({
                    url: `/fp/fp12mexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    fp12mprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/fp/fp12mprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    fp12mlayout(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`fp/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`fp/fp12mlayout/${encodeURIComponent(obj.layout)}/${encodeURIComponent(obj.tahun)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },


    rptfp(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fp/rptfp${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rptfpprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/fp/rptfpprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    rptfpexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/fp/rptfpexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Financial_position_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });

    },
    layout(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`fp/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`fpfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layout_combo() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`fpfmt/combo`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutDel(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`fpfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutSave(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("fpfmt", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};